(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sewtech-bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT_SELECTOR = '[data-sewtech-bundle-selector]';
    var originalAttributes = new WeakMap();
    var originalFormState = new WeakMap();

    function rememberAttributes(element, attributes) {
      if (!element || originalAttributes.has(element)) return;
      var snapshot = {};
      attributes.forEach(function (attribute) {
        snapshot[attribute] = element.getAttribute(attribute);
      });
      originalAttributes.set(element, snapshot);
    }

    function restoreAttributes(element) {
      if (!element || !originalAttributes.has(element)) return;
      var snapshot = originalAttributes.get(element);
      Object.keys(snapshot).forEach(function (attribute) {
        if (snapshot[attribute] === null) {
          element.removeAttribute(attribute);
        } else {
          element.setAttribute(attribute, snapshot[attribute]);
        }
      });
      element.removeAttribute('data-sewtech-bundle-preview');
    }

    function setPreviewImage(element, source, alt) {
      if (!element) return;
      rememberAttributes(element, ['src', 'srcset', 'sizes', 'alt', 'width', 'height']);
      element.removeAttribute('srcset');
      element.setAttribute('src', source);
      element.setAttribute('alt', alt);
      element.setAttribute('width', '560');
      element.setAttribute('height', '560');
      element.setAttribute('data-sewtech-bundle-preview', 'true');
    }

    function getProductInfo(root) {
      return root.closest('product-info');
    }

    function getGalleryElements(root) {
      var productInfo = getProductInfo(root);
      if (!productInfo) return {};
      var mainLink = productInfo.querySelector('[data-sewtech-bundle-main-link]') ||
        productInfo.querySelector('a[aria-label="Open media 1 in modal"]');
      var thumbnailButton = productInfo.querySelector('[data-sewtech-bundle-thumbnail]') ||
        productInfo.querySelector('button[aria-label="Load image 1 in gallery view"]');
      if (mainLink) mainLink.setAttribute('data-sewtech-bundle-main-link', 'true');
      if (thumbnailButton) thumbnailButton.setAttribute('data-sewtech-bundle-thumbnail', 'true');
      return {
        mainLink: mainLink,
        mainImage: mainLink ? mainLink.querySelector('img') : null,
        thumbnailImage: thumbnailButton ? thumbnailButton.querySelector('img') : null
      };
    }

    function getHeroSource(selected) {
      var template = selected.querySelector('[data-bundle-hero-source]');
      return template ? template.content.textContent.trim() : '';
    }

    function updateGallery(root, selected) {
      var gallery = getGalleryElements(root);
      var heroSource = getHeroSource(selected);
      rememberAttributes(gallery.mainLink, ['href', 'data-pswp-width', 'data-pswp-height']);
      rememberAttributes(gallery.mainImage, ['src', 'srcset', 'sizes', 'alt', 'width', 'height']);
      rememberAttributes(gallery.thumbnailImage, ['src', 'srcset', 'sizes', 'alt', 'width', 'height']);
      if (!heroSource) {
        restoreAttributes(gallery.mainLink);
        restoreAttributes(gallery.mainImage);
        restoreAttributes(gallery.thumbnailImage);
        return;
      }
      var alt = selected.dataset.bundleName;
      setPreviewImage(gallery.mainImage, heroSource, alt);
      setPreviewImage(gallery.thumbnailImage, heroSource, alt);
      if (gallery.mainLink) {
        gallery.mainLink.setAttribute('href', heroSource);
        gallery.mainLink.setAttribute('data-pswp-width', '560');
        gallery.mainLink.setAttribute('data-pswp-height', '560');
        gallery.mainLink.setAttribute('data-sewtech-bundle-preview', 'true');
      }
    }

    function updatePriceRoot(root, price, compare) {
      if (!root) return;
      var shells = [];
      if (root.matches('.price')) shells.push(root);
      Array.prototype.push.apply(shells, root.querySelectorAll('.price'));
      shells.forEach(function (shell) {
        shell.classList.toggle('price--on-sale', Boolean(compare));
      });
      root.querySelectorAll('.price__regular .price-item--regular').forEach(function (element) {
        element.textContent = compare || price;
      });
      root.querySelectorAll('.price__sale s.price-item--regular').forEach(function (element) {
        element.textContent = compare;
      });
      root.querySelectorAll('.price__sale .price-item--sale').forEach(function (element) {
        element.textContent = price;
      });
    }

    function getSectionId(root) {
      var productInfo = getProductInfo(root);
      return productInfo ? productInfo.dataset.section || '' : '';
    }

    function updateProductPrices(root, selected) {
      var sectionId = getSectionId(root);
      var price = selected.dataset.bundlePrice || '';
      var compare = selected.dataset.bundleCompare || '';
      var mainPrice = document.getElementById('price-' + sectionId);
      var stickyPrice = document.getElementById('price-Sticky-' + sectionId);
      updatePriceRoot(mainPrice, price, compare);
      updatePriceRoot(stickyPrice, price, compare);
      if (mainPrice) {
        var note = mainPrice.querySelector('[data-sewtech-bundle-price-note]');
        if (!note) {
          note = document.createElement('span');
          note.className = 'sewtech-bundle-selector__price-note';
          note.setAttribute('data-sewtech-bundle-price-note', '');
          mainPrice.appendChild(note);
        }
        note.hidden = selected.dataset.bundleKey === root.dataset.standardKey;
        note.textContent = selected.dataset.bundleHasProduct === 'true' ? root.dataset.bundlePriceNote : root.dataset.demoPriceNote;
      }
    }

    function getProductForms(root) {
      var sectionId = getSectionId(root);
      if (!sectionId) return [];
      return [
        document.getElementById('product-form-' + sectionId),
        document.getElementById('product-form-Sticky-' + sectionId)
      ].filter(Boolean);
    }

    function rememberFormState(form) {
      if (!form || originalFormState.has(form)) return originalFormState.get(form);
      var variantInput = form.querySelector('input[name="id"]');
      var submitButton = form.querySelector('button[name="add"]');
      var submitLabel = submitButton ? submitButton.querySelector('span') : null;
      var paymentButton = form.querySelector('.shopify-payment-button');
      var state = {
        variantInput: variantInput,
        variantId: variantInput ? variantInput.value : '',
        variantDisabled: variantInput ? variantInput.disabled : false,
        submitButton: submitButton,
        submitDisabled: submitButton ? submitButton.disabled : false,
        submitAriaDisabled: submitButton ? submitButton.getAttribute('aria-disabled') : null,
        submitLabel: submitLabel,
        submitText: submitLabel ? submitLabel.textContent : '',
        paymentButton: paymentButton,
        paymentHidden: paymentButton ? paymentButton.hidden : false
      };
      originalFormState.set(form, state);
      return state;
    }

    function restoreAttribute(element, name, value) {
      if (!element) return;
      if (value === null) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value);
      }
    }

    function setFormBundleProperty(form, value) {
      var propertyInput = form.querySelector('[data-sewtech-bundle-property]');
      if (!value) {
        if (propertyInput) propertyInput.remove();
        return;
      }
      if (!propertyInput) {
        propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = 'properties[Bundle]';
        propertyInput.setAttribute('data-sewtech-bundle-property', '');
        form.appendChild(propertyInput);
      }
      propertyInput.value = value;
    }

    function updateProductForms(root, selected) {
      var isStandard = selected.dataset.bundleKey === root.dataset.standardKey;
      var hasProduct = selected.dataset.bundleHasProduct === 'true';
      var available = selected.dataset.bundleAvailable === 'true';
      var variantId = selected.dataset.bundleVariantId || '';
      getProductForms(root).forEach(function (form) {
        var state = rememberFormState(form);
        if (!state || !state.variantInput || !state.submitButton) return;
        if (isStandard) {
          state.variantInput.value = state.variantId;
          state.variantInput.setAttribute('value', state.variantId);
          state.variantInput.disabled = state.variantDisabled;
          state.submitButton.disabled = state.submitDisabled;
          restoreAttribute(state.submitButton, 'aria-disabled', state.submitAriaDisabled);
          if (state.submitLabel) state.submitLabel.textContent = state.submitText;
          if (state.paymentButton) state.paymentButton.hidden = state.paymentHidden;
          setFormBundleProperty(form, '');
          return;
        }
        if (hasProduct && available && variantId) {
          state.variantInput.value = variantId;
          state.variantInput.setAttribute('value', variantId);
          state.variantInput.disabled = false;
          state.submitButton.disabled = false;
          state.submitButton.removeAttribute('aria-disabled');
          if (state.submitLabel) state.submitLabel.textContent = root.dataset.addBundleText;
          if (state.paymentButton) state.paymentButton.hidden = true;
          setFormBundleProperty(form, selected.dataset.bundleName || 'Bundle');
          return;
        }
        state.variantInput.disabled = true;
        state.submitButton.disabled = true;
        state.submitButton.setAttribute('aria-disabled', 'true');
        if (state.submitLabel) {
          state.submitLabel.textContent = hasProduct ? root.dataset.soldOutText : root.dataset.demoOnlyText;
        }
        if (state.paymentButton) state.paymentButton.hidden = true;
        setFormBundleProperty(form, '');
      });
    }

    function getBundleOptions(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bundle-key]'));
    }

    function getInitialOptionLimit(root) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var value = isMobile ? root.dataset.mobileInitialOptions : root.dataset.desktopInitialOptions;
      var fallback = isMobile ? 3 : 4;
      var parsed = parseInt(value, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }

    function getViewAllText(root, optionCount) {
      var template = root.dataset.viewAllText || 'View all [count] bundles';
      return template.replace(/\[count\]/g, optionCount);
    }

    function updateDisclosure(root) {
      var options = getBundleOptions(root);
      var disclosure = root.querySelector('[data-bundle-disclosure]');
      if (!disclosure) return;
      var limit = Math.min(getInitialOptionLimit(root), options.length);
      var shouldCollapse = options.length > 4 && options.length > limit;
      var isExpanded = root.dataset.bundleExpanded === 'true';
      if (!shouldCollapse) {
        options.forEach(function (option) {
          option.hidden = false;
        });
        disclosure.hidden = true;
        disclosure.setAttribute('aria-expanded', 'true');
        return;
      }
      var selectedIndex = options.findIndex(function (option) {
        return option.dataset.bundleKey === root.dataset.selectedBundle;
      });
      var visibleIndexes = {};
      options.forEach(function (option, index) {
        if (isExpanded || index < limit) visibleIndexes[index] = true;
      });
      if (!isExpanded && selectedIndex >= limit) {
        delete visibleIndexes[Math.max(0, limit - 1)];
        visibleIndexes[selectedIndex] = true;
      }
      options.forEach(function (option, index) {
        option.hidden = !visibleIndexes[index];
      });
      disclosure.hidden = false;
      disclosure.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      disclosure.textContent = isExpanded ? (root.dataset.showFewerText || 'Show fewer') : getViewAllText(root, options.length);
      disclosure.setAttribute('aria-label', disclosure.textContent + ' (' + options.length + ' bundle options)');
    }

    function selectBundle(root, key, shouldFocus) {
      var options = getBundleOptions(root);
      var selected = options.find(function (option) {
        return option.dataset.bundleKey === key;
      }) || options[0];
      if (!selected) return;
      options.forEach(function (option) {
        var active = option === selected;
        option.classList.toggle('is-selected', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
        var label = option.querySelector('[data-selected-label]');
        if (label) label.hidden = !active;
      });
      updateGallery(root, selected);
      updateProductPrices(root, selected);
      updateProductForms(root, selected);
      var name = selected.dataset.bundleName || '';
      var price = selected.dataset.bundlePrice || '';
      var liveRegion = root.querySelector('[data-bundle-live]');
      if (liveRegion) liveRegion.textContent = name + ' ' + root.dataset.selectedText + ': ' + price;
      var url = new URL(window.location.href);
      url.searchParams.set('bundle', selected.dataset.bundleKey);
      window.history.replaceState({}, '', url.toString());
      root.dataset.selectedBundle = selected.dataset.bundleKey;
      updateDisclosure(root);
      if (shouldFocus) selected.focus({ preventScroll: true });
      window.dispatchEvent(new CustomEvent('sewtech:bundle-change', {
        detail: {
          key: selected.dataset.bundleKey,
          name: name,
          price: price,
          compare: selected.dataset.bundleCompare || '',
          purchasable: selected.dataset.bundleHasProduct === 'true',
          available: selected.dataset.bundleAvailable === 'true',
          variantId: selected.dataset.bundleVariantId || null
        }
      }));
    }

    function init(root) {
      if (root.dataset.bundleReady === 'true') return;
      root.dataset.bundleReady = 'true';
      root.dataset.bundleExpanded = 'false';
      getProductForms(root).forEach(rememberFormState);
      root.addEventListener('click', function (event) {
        var disclosure = event.target.closest('[data-bundle-disclosure]');
        if (disclosure && root.contains(disclosure)) {
          root.dataset.bundleExpanded = root.dataset.bundleExpanded === 'true' ? 'false' : 'true';
          updateDisclosure(root);
          return;
        }
        var option = event.target.closest('[data-bundle-key]');
        if (!option || !root.contains(option)) return;
        selectBundle(root, option.dataset.bundleKey, false);
      });
      getProductForms(root).forEach(function (form) {
        form.addEventListener('submit', function () {
          var selected = root.querySelector('[data-bundle-key].is-selected');
          if (selected) updateProductForms(root, selected);
        }, true);
      });
      var params = new URL(window.location.href).searchParams;
      selectBundle(root, params.get('bundle') || root.dataset.defaultBundle || root.dataset.standardKey, false);
    }

    function initAll(container) {
      var scope = container && container.querySelectorAll ? container : document;
      if (scope.matches && scope.matches(ROOT_SELECTOR)) init(scope);
      scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var option = event.target.closest('[data-bundle-key]');
      var root = option ? option.closest(ROOT_SELECTOR) : null;
      if (!root) return;
      init(root);
      selectBundle(root, option.dataset.bundleKey, true);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        document.querySelectorAll(ROOT_SELECTOR).forEach(updateDisclosure);
      }, 120);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sewtech-st1501-bundle-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    var ROOT_SELECTOR = '[data-sewtech-st1501-bundle-selector]';
    var originalAttributes = new WeakMap();
    var originalFormState = new WeakMap();

    function rememberAttributes(element, attributes) {
      if (!element || originalAttributes.has(element)) return;
      var snapshot = {};
      attributes.forEach(function (attribute) {
        snapshot[attribute] = element.getAttribute(attribute);
      });
      originalAttributes.set(element, snapshot);
    }

    function restoreAttributes(element) {
      if (!element || !originalAttributes.has(element)) return;
      var snapshot = originalAttributes.get(element);
      Object.keys(snapshot).forEach(function (attribute) {
        if (snapshot[attribute] === null) {
          element.removeAttribute(attribute);
        } else {
          element.setAttribute(attribute, snapshot[attribute]);
        }
      });
      element.removeAttribute('data-sewtech-bundle-preview');
    }

    function setPreviewImage(element, source, alt) {
      if (!element) return;
      rememberAttributes(element, ['src', 'srcset', 'sizes', 'alt', 'width', 'height']);
      element.removeAttribute('srcset');
      element.setAttribute('src', source);
      element.setAttribute('alt', alt);
      element.setAttribute('width', '560');
      element.setAttribute('height', '560');
      element.setAttribute('data-sewtech-bundle-preview', 'true');
    }

    function getProductInfo(root) {
      return root.closest('product-info');
    }

    function getGalleryElements(root) {
      var productInfo = getProductInfo(root);
      if (!productInfo) return {};
      var mainLink = productInfo.querySelector('[data-sewtech-bundle-main-link]') ||
        productInfo.querySelector('.product__media-item .product__modal-opener--image');
      var thumbnailButton = productInfo.querySelector('[data-sewtech-bundle-thumbnail]') ||
        productInfo.querySelector('.thumbnail-list button.thumbnail');
      if (mainLink) mainLink.setAttribute('data-sewtech-bundle-main-link', 'true');
      if (thumbnailButton) thumbnailButton.setAttribute('data-sewtech-bundle-thumbnail', 'true');
      return {
        mainLink: mainLink,
        mainImage: mainLink ? mainLink.querySelector('img') : null,
        thumbnailImage: thumbnailButton ? thumbnailButton.querySelector('img') : null
      };
    }

    function getHeroSource(selected) {
      var template = selected.querySelector('[data-bundle-hero-source]');
      return template ? template.content.textContent.trim() : '';
    }

    function updateGallery(root, selected) {
      var gallery = getGalleryElements(root);
      var heroSource = getHeroSource(selected);
      rememberAttributes(gallery.mainLink, ['href', 'data-pswp-width', 'data-pswp-height']);
      rememberAttributes(gallery.mainImage, ['src', 'srcset', 'sizes', 'alt', 'width', 'height']);
      rememberAttributes(gallery.thumbnailImage, ['src', 'srcset', 'sizes', 'alt', 'width', 'height']);
      if (!heroSource) {
        restoreAttributes(gallery.mainLink);
        restoreAttributes(gallery.mainImage);
        restoreAttributes(gallery.thumbnailImage);
        return;
      }
      var alt = selected.dataset.bundleName;
      setPreviewImage(gallery.mainImage, heroSource, alt);
      setPreviewImage(gallery.thumbnailImage, heroSource, alt);
      if (gallery.mainLink) {
        gallery.mainLink.setAttribute('href', heroSource);
        gallery.mainLink.setAttribute('data-pswp-width', '560');
        gallery.mainLink.setAttribute('data-pswp-height', '560');
        gallery.mainLink.setAttribute('data-sewtech-bundle-preview', 'true');
      }
    }

    function updatePriceRoot(root, price, compare) {
      if (!root) return;
      var shells = [];
      if (root.matches('.price')) shells.push(root);
      Array.prototype.push.apply(shells, root.querySelectorAll('.price'));
      shells.forEach(function (shell) {
        shell.classList.toggle('price--on-sale', Boolean(compare));
      });
      root.querySelectorAll('.price__regular .price-item--regular').forEach(function (element) {
        element.textContent = compare || price;
      });
      root.querySelectorAll('.price__sale s.price-item--regular').forEach(function (element) {
        element.textContent = compare;
      });
      root.querySelectorAll('.price__sale .price-item--sale').forEach(function (element) {
        element.textContent = price;
      });
    }

    function getSectionId(root) {
      var productInfo = getProductInfo(root);
      return productInfo ? productInfo.dataset.section || '' : '';
    }

    function updateProductPrices(root, selected) {
      var sectionId = getSectionId(root);
      var price = selected.dataset.bundlePrice || '';
      var compare = selected.dataset.bundleCompare || '';
      var mainPrice = document.getElementById('price-' + sectionId);
      var stickyPrice = document.getElementById('price-Sticky-' + sectionId);
      updatePriceRoot(mainPrice, price, compare);
      updatePriceRoot(stickyPrice, price, compare);
      if (mainPrice) {
        var note = mainPrice.querySelector('[data-sewtech-bundle-price-note]');
        if (!note) {
          note = document.createElement('span');
          note.className = 'sewtech-st1501-bundle-selector__price-note';
          note.setAttribute('data-sewtech-bundle-price-note', '');
          mainPrice.appendChild(note);
        }
        note.hidden = selected.dataset.bundleKey === root.dataset.standardKey;
        note.textContent = selected.dataset.bundlePricePending === 'true' ? root.dataset.pendingButtonText : (selected.dataset.bundleHasProduct === 'true' ? root.dataset.bundlePriceNote : root.dataset.demoPriceNote);
      }
    }

    function getProductForms(root) {
      var sectionId = getSectionId(root);
      if (!sectionId) return [];
      return [
        document.getElementById('product-form-' + sectionId),
        document.getElementById('product-form-Sticky-' + sectionId)
      ].filter(Boolean);
    }

    function rememberFormState(form) {
      if (!form || originalFormState.has(form)) return originalFormState.get(form);
      var variantInput = form.querySelector('input[name="id"]');
      var submitButton = form.querySelector('button[name="add"]');
      var submitLabel = submitButton ? submitButton.querySelector('span') : null;
      var paymentButton = form.querySelector('.shopify-payment-button');
      var state = {
        variantInput: variantInput,
        variantId: variantInput ? variantInput.value : '',
        variantDisabled: variantInput ? variantInput.disabled : false,
        submitButton: submitButton,
        submitDisabled: submitButton ? submitButton.disabled : false,
        submitAriaDisabled: submitButton ? submitButton.getAttribute('aria-disabled') : null,
        submitLabel: submitLabel,
        submitText: submitLabel ? submitLabel.textContent : '',
        paymentButton: paymentButton,
        paymentHidden: paymentButton ? paymentButton.hidden : false
      };
      originalFormState.set(form, state);
      return state;
    }

    function restoreAttribute(element, name, value) {
      if (!element) return;
      if (value === null) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value);
      }
    }

    function setFormBundleProperty(form, value) {
      var propertyInput = form.querySelector('[data-sewtech-bundle-property]');
      if (!value) {
        if (propertyInput) propertyInput.remove();
        return;
      }
      if (!propertyInput) {
        propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = 'properties[Bundle]';
        propertyInput.setAttribute('data-sewtech-bundle-property', '');
        form.appendChild(propertyInput);
      }
      propertyInput.value = value;
    }

    function updateProductForms(root, selected) {
      var isStandard = selected.dataset.bundleKey === root.dataset.standardKey;
      var hasProduct = selected.dataset.bundleHasProduct === 'true';
      var restricted = selected.dataset.bundleUsRestricted === 'true';
      var available = selected.dataset.bundleAvailable === 'true' && !restricted;
      var variantId = selected.dataset.bundleVariantId || '';
      getProductForms(root).forEach(function (form) {
        var state = rememberFormState(form);
        if (!state || !state.variantInput || !state.submitButton) return;
        state.submitButton.toggleAttribute('data-sewtech-us-restricted', restricted);
        if (isStandard) {
          state.variantInput.value = state.variantId;
          state.variantInput.setAttribute('value', state.variantId);
          state.variantInput.disabled = state.variantDisabled;
          state.submitButton.disabled = state.submitDisabled;
          restoreAttribute(state.submitButton, 'aria-disabled', state.submitAriaDisabled);
          if (state.submitLabel) state.submitLabel.textContent = state.submitText;
          if (state.paymentButton) state.paymentButton.hidden = state.paymentHidden;
          setFormBundleProperty(form, '');
          return;
        }
        if (hasProduct && available && variantId) {
          state.variantInput.value = variantId;
          state.variantInput.setAttribute('value', variantId);
          state.variantInput.disabled = false;
          state.submitButton.disabled = false;
          state.submitButton.removeAttribute('aria-disabled');
          if (state.submitLabel) state.submitLabel.textContent = root.dataset.addBundleText;
          if (state.paymentButton) state.paymentButton.hidden = true;
          setFormBundleProperty(form, selected.dataset.bundleName || '');
          return;
        }
        state.variantInput.disabled = true;
        state.submitButton.disabled = true;
        state.submitButton.setAttribute('aria-disabled', 'true');
        if (state.submitLabel) {
          state.submitLabel.textContent = restricted ? root.dataset.usRestrictedText : (selected.dataset.bundlePricePending === 'true' ? root.dataset.pendingButtonText : (hasProduct ? root.dataset.soldOutText : root.dataset.demoOnlyText));
        }
        if (state.paymentButton) state.paymentButton.hidden = true;
        setFormBundleProperty(form, '');
      });
    }

    function getBundleOptions(root) {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bundle-key]'));
    }

    function getInitialOptionLimit(root) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var value = isMobile ? root.dataset.mobileInitialOptions : root.dataset.desktopInitialOptions;
      var fallback = isMobile ? 3 : 4;
      var parsed = parseInt(value, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
    }

    function getViewAllText(root, optionCount) {
      var template = root.dataset.viewAllText || '';
      return template.replace(/\[count\]/g, optionCount);
    }

    function updateDisclosure(root) {
      var options = getBundleOptions(root);
      var disclosure = root.querySelector('[data-bundle-disclosure]');
      if (!disclosure) return;
      var limit = Math.min(getInitialOptionLimit(root), options.length);
      var shouldCollapse = options.length > 4 && options.length > limit;
      var isExpanded = root.dataset.bundleExpanded === 'true';
      if (!shouldCollapse) {
        options.forEach(function (option) {
          var item = option.closest('[data-bundle-item]');
          (item || option).hidden = false;
        });
        disclosure.hidden = true;
        disclosure.setAttribute('aria-expanded', 'true');
        return;
      }
      var selectedIndex = options.findIndex(function (option) {
        return option.dataset.bundleKey === root.dataset.selectedBundle;
      });
      var visibleIndexes = {};
      options.forEach(function (option, index) {
        if (isExpanded || index < limit) visibleIndexes[index] = true;
      });
      if (!isExpanded && selectedIndex >= limit) {
        delete visibleIndexes[Math.max(0, limit - 1)];
        visibleIndexes[selectedIndex] = true;
      }
      options.forEach(function (option, index) {
        var item = option.closest('[data-bundle-item]');
        (item || option).hidden = !visibleIndexes[index];
      });
      disclosure.hidden = false;
      disclosure.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      disclosure.textContent = isExpanded ? root.dataset.showFewerText : getViewAllText(root, options.length);
      disclosure.setAttribute('aria-label', disclosure.textContent);
    }

    function selectBundle(root, key, shouldFocus, expandDetails) {
      var options = getBundleOptions(root);
      var selected = options.find(function (option) {
        return option.dataset.bundleKey === key;
      }) || options[0];
      if (!selected) return;
      options.forEach(function (option) {
        var active = option === selected;
        var item = option.closest('[data-bundle-item]');
        var details = item ? item.querySelector('[data-bundle-details]') : null;
        option.classList.toggle('is-selected', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (item) item.classList.toggle('is-selected', active);
        if (details) {
          var expanded = active && expandDetails !== false;
          details.hidden = !expanded;
          option.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
        var label = option.querySelector('[data-selected-label]');
        if (label) label.hidden = !active;
      });
      updateGallery(root, selected);
      updateProductPrices(root, selected);
      updateProductForms(root, selected);
      var name = selected.dataset.bundleName || '';
      var price = selected.dataset.bundlePrice || '';
      var liveRegion = root.querySelector('[data-bundle-live]');
      if (liveRegion) liveRegion.textContent = (root.dataset.announcement || '').replace('[name]', function () { return name; }).replace('[price]', function () { return price; });
      var url = new URL(window.location.href);
      url.searchParams.set('bundle', selected.dataset.bundleKey);
      window.history.replaceState({}, '', url.toString());
      root.dataset.selectedBundle = selected.dataset.bundleKey;
      updateDisclosure(root);
      if (shouldFocus) selected.focus({ preventScroll: true });
      window.dispatchEvent(new CustomEvent('sewtech:bundle-change', {
        detail: {
          key: selected.dataset.bundleKey,
          name: name,
          price: price,
          compare: selected.dataset.bundleCompare || '',
          purchasable: selected.dataset.bundleHasProduct === 'true' && selected.dataset.bundlePricePending !== 'true',
          available: selected.dataset.bundleAvailable === 'true' && selected.dataset.bundleUsRestricted !== 'true',
          variantId: selected.dataset.bundleVariantId || null
        }
      }));
    }

    function isolateRtlSpecifications(root) {
      if (root.dataset.detailsToggle !== 'true' || root.dir !== 'rtl') return;
      var tokens = /(?:ST|SC)-\d+|PRMS\d+|HoopSteady|×\s*\d+|\d+(?:\.\d+)?(?:(?:"?[x×/])\d+(?:\.\d+)?)*"?(?:mm|m)?/g;
      root.querySelectorAll('.sewtech-st1501-bundle-selector__title, .sewtech-st1501-bundle-selector__details-list li > span').forEach(function (element) {
        var text = element.textContent;
        var fragment = document.createDocumentFragment();
        var end = 0;
        tokens.lastIndex = 0;
        var match;
        while ((match = tokens.exec(text)) !== null) {
          fragment.appendChild(document.createTextNode(text.slice(end, match.index)));
          var token = document.createElement('bdi');
          token.dir = 'ltr';
          token.textContent = match[0];
          fragment.appendChild(token);
          end = tokens.lastIndex;
        }
        if (end === 0) return;
        fragment.appendChild(document.createTextNode(text.slice(end)));
        element.replaceChildren(fragment);
      });
    }

    function init(root) {
      if (root.dataset.bundleReady === 'true') return;
      isolateRtlSpecifications(root);
      root.dataset.bundleReady = 'true';
      root.dataset.bundleExpanded = 'false';
      getProductForms(root).forEach(rememberFormState);
      root.addEventListener('click', function (event) {
        var disclosure = event.target.closest('[data-bundle-disclosure]');
        if (disclosure && root.contains(disclosure)) {
          root.dataset.bundleExpanded = root.dataset.bundleExpanded === 'true' ? 'false' : 'true';
          updateDisclosure(root);
          return;
        }
        var option = event.target.closest('[data-bundle-key]');
        if (!option || !root.contains(option)) return;
        if (root.dataset.detailsToggle === 'true' && option.getAttribute('aria-pressed') === 'true' && option.hasAttribute('aria-expanded')) {
          var details = option.closest('[data-bundle-item]').querySelector('[data-bundle-details]');
          if (details) {
            var expanded = option.getAttribute('aria-expanded') !== 'true';
            details.hidden = !expanded;
            option.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            return;
          }
        }
        selectBundle(root, option.dataset.bundleKey, false);
      });
      getProductForms(root).forEach(function (form) {
        form.addEventListener('submit', function (event) {
          var selected = root.querySelector('[data-bundle-key].is-selected');
          if (selected) updateProductForms(root, selected);
          if (selected && (selected.dataset.bundlePricePending === 'true' || selected.dataset.bundleUsRestricted === 'true')) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
      });
      var params = new URL(window.location.href).searchParams;
      selectBundle(root, params.get('bundle') || root.dataset.defaultBundle || root.dataset.standardKey, false, root.dataset.detailsToggle !== 'true');
    }

    function initAll(container) {
      var scope = container && container.querySelectorAll ? container : document;
      if (scope.matches && scope.matches(ROOT_SELECTOR)) init(scope);
      scope.querySelectorAll(ROOT_SELECTOR).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var option = event.target.closest('[data-bundle-key]');
      var root = option ? option.closest(ROOT_SELECTOR) : null;
      if (!root) return;
      init(root);
      selectBundle(root, option.dataset.bundleKey, true);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        document.querySelectorAll(ROOT_SELECTOR).forEach(updateDisclosure);
      }, 120);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
